export default __webpack_public_path__ + "static/media/1_YUAN400.d348be15.jpg";